import { ISubProject } from '@/modules/dap/interfaces';

export class SubProject implements ISubProject {
  description = '';
  createdAt = new Date();
  finalHistoryPeriod = new Date();
  id = 0;
  idFamilyGroup = 0;
  idProject = 0;
  idSegmentGroup = 0;
  initialHistoryPeriod = new Date();
  isSelected = false;
  dapMethodologyType = 0;
  limitPercentAbove = 0;
  limitPercentBelow = 0;
  initialDateProject = new Date();
  idMarketShareReferenceType = 0;
  subProjectLimits = [];
  marketShareInferior = 0;
  marketShareMedium = 0;
  marketShareSuperior = 0;
  name = '';
  saleTargets = [];
  cfgIndexMtdMarketShare = [];
  indexType = 2;
  totalInfluence = 0;
  familySegmentInfluence = 0;
  percentSegmentInfluence = 0;
  percentMarketLevelInfluence = 0;
  percentDapInfluence = 0;
  cfgMtdPlanInfluences = [];
}
